export default class AdminResource {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/resources`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPermissionsEndpoint}/resources/${id}`)
  }

  create(payload) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPermissionsEndpoint}/resources`, payload);
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPermissionsEndpoint}/resources/${id}`, payload)
  }

  deactivate(id, payload) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPermissionsEndpoint}/resources/${id}`, payload)
  }
}
